<h1>{{ getTitle() }} d'un plan de pr&eacute;vention</h1>
<form class="form-horizontal">
	<mat-horizontal-stepper linear #stepper (selectionChange)="stepChange($event)">
		<!--################################### STEP 1 ######################################-->
		<!-- ---------------------------Définition de l'opération------------------------------ -->
		<mat-step label="D&eacute;finition de l&rsquo;op&eacute;ration" #step1>
		<info-generales [mandatoryField]="mandatoryStepOne" [infosGeneraleCommands]="infosGeneraleCommands" 
			(energieChange)="onEnergieChange($event)" (antenneChange)="onAntenneChange($event)"
			(modelChange)="onInfoGeneralesModelChange($event)" >
		</info-generales>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-warning" [disabled]="isDisabled(1)" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				</div>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-success" [disabled]="isDisabled(1)" (click)="onCompletingDefinitionOperation(stepper)">Next</button>
				</div>
			</div>
		</mat-step>

		<!--################################### STEP 2 ######################################-->
		<mat-step label="Travaux - Entreprise" #step2>
			<div>
				<!-- ---------------------------Travaux - Entreprise-------------------------------- -->
				<pannel [title]="'Travaux'">
					<button type="button" class="btn btn-primary btn-ajout" (click)="addTravaux()">Ajouter *</button>
					<table class="travaux">
						<th>Lots / N°</th>
						<th>D&eacute;signation &lowast;</th>
						<th>Entreprise (AURORA) &lowast;</th>
						<th>Sous-Traitants (AURORA)</th>
						<th>Coactivit&eacute;</th>
						<tr *ngFor="let element of travaux; let indexTr = index">
							<td>{{ element.id }}</td>
							<td>
								<no-input-reset-filterable-select
									[maxLength]="100"
									[inputClass]="'form-control' + (mandatoryStepTwo ? ' highlightable' : '')"
									[list]="typeMaintenanceSuggestion"
									[labelGetter]="getSuggestedTypeMaintenanceCode"
									[initialValue]="designationInitialValueSubject[indexTr]"
									[disabled]="planPreventionModel.mode === 'update' && !(planPreventionModel.etat === 3 || planPreventionModel.etat === 0)"
									(selectedItemChange)="onDesignationChange($event, element)"
									(change)="onDesignationChange($event, element)" >
								</no-input-reset-filterable-select>
							</td>
							<td class="entreprise">
								<div class="input-group chosenEntreprises" style="width: 100%" *ngFor="let selection of travaux[element.id - 1].selectedEntreprises; let index = index">
									<div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
										<input type="text" class="form-control" [value]="selection.entreprise.nom" readonly />
										<div class="input-group-addon">
											<a href="#" onclick="return false;" (click)="onEntrepriseDeselected(index, element)">
												<span class="fa fa-minus-circle fa-lg"></span>
											</a>
										</div>
									</div>
								</div>
								<div class="input-group filterableEntreprises" style="width: 100%">
									<div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
										<filterable-select
												[inputClass]="'form-control' + (mandatoryStepTwo ? ' highlightable' : '')"
												[list]="travaux[element.id - 1].availableEntreprises"
												[labelGetter]="getEntrepriseLabel"
												[(selectedItem)]="travaux[element.id - 1].selectedEntreprise"
												(selectedItemChange)="onEntrepriseSelected($event, element)" >
										</filterable-select>
										<div class="input-group-addon">
											<a href="#" onclick="return false;">
												<span class="fa fa-plus-circle fa-lg"></span>
											</a>
										</div>
									</div>
								</div>
							</td>
							<td class="entreprise">
								<div class="input-group chosenEntreprises" style="width: 100%" *ngFor="let selection of travaux[element.id - 1].selectedSousTraitants let index = index">
									<div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
										<input
												type="text"
												class="form-control"
												[value]="selection.entreprise.nom"
												readonly />
										<div class="input-group-addon">
											<a href="#" onclick="return false;" (click)="onSousTraitantDeselected(index, element)">
												<span class="fa fa-minus-circle fa-lg"></span>
											</a>
										</div>
									</div>
								</div>
								<div class="input-group filterableEntreprises" style="width: 100%">
									<div class="input-group col-md-10.plus-half" style="padding-left: 0px; float: left;">
										<filterable-select
												[inputClass]="'form-control'"
												[list]="travaux[element.id - 1].availableEntreprises"
												[labelGetter]="getEntrepriseLabel"
												[(selectedItem)]="travaux[element.id - 1].selectedSousTraitant"
												(selectedItemChange)="onSousTraitantSelected($event, element)"
										>
										</filterable-select>
										<div class="input-group-addon">
											<a href="#" onclick="return false;">
												<span class="fa fa-plus-circle fa-lg"></span>
											</a>
										</div>
									</div>
								</div>
							</td>
							<td>
								<mat-radio-group color="primary" [(ngModel)]="element.coactivite" [ngModelOptions]="{standalone: true}" >
									<mat-radio-button *ngFor="let coactivite of listeCoactivite" [value]="coactivite"  [checked]="coactivite === element.coactivite" >
										{{coactivite}}
									</mat-radio-button>
								</mat-radio-group>
								<i class="fa fa-trash fa-2x text-danger" style="margin-left: 12px;" (click)="planPreventionModel.mode === 'update' && !(planPreventionModel.etat === 3 || planPreventionModel.etat === 0) ? false : removeLotTravaux(element.id)"></i>
							</td>
						</tr>
					</table>
				</pannel>

				<!-- ------------------------- Entreprises Utilisatrices ---------------------------- -->
				<pannel [title]="'Entreprise Utilisatrice'">
					<div class="row row-margin">
						<!-- Raison sociale -->
						<label for="raisonsociale" class="col-md-1 plus-half">Raison Sociale&nbsp;: </label>
						<div id="raisonsociale" class="col-md-2 plus-half padding-adjust">
							<input id="raisonsocialeInput" name="raisonsocialeInput" class="form-control" type="text" [(ngModel)]="raisonSociale" [maxLength]="255" />
						</div>
						<!-- Adresse Entreprise Utilisatrice -->
						<label for="adresseeu" class="col-md-1">Adresse&nbsp;: </label>
						<div class="col-md-3 padding-adjust">
							<input id="adresseEU" name="adresseEU" class="form-control" type="text" [(ngModel)]="adresseEU" [maxLength]="255" />
						</div>
						<!-- Téléphone et fax -->
						<label for="telephonefax" class="col-md-2">T&eacute;l&eacute;phone et Fax&nbsp;: </label>
						<div class="col-md-2 padding-adjust">
							<input id="telFax" name="telFax" class="form-control" type="text" [(ngModel)]="telFax" [maxLength]="255" />
						</div>
					</div>
					<div class="row row-margin">
						<!-- Nom, prenom référent -->
						<label for="nomreferent" class="col-md-1 plus-half">Nom R&eacute;f&eacute;rent&nbsp;:</label>
						<div class="col-md-2 plus-half padding-adjust">
							<input id="nomPrenomReferent" name="nomPrenomReferent" class="form-control" type="text" [(ngModel)]="nomPrenomReferent" [maxLength]="255" />
						</div>
						<!-- email referent -->
						<label for="emailreferent" class="col-md-1">Email R&eacute;f&eacute;rent&nbsp;:</label>
						<div class="col-md-3 padding-adjust">
							<input id="emailReferent" name="emailReferent" class="form-control" type="text" [(ngModel)]="emailReferent" [maxLength]="255" />
						</div>
						<!-- Telephone referent -->
						<label for="emailgenerique" class="col-md-2">Email G&eacute;n&eacute;rique&nbsp;:</label>
						<div class="col-md-2 padding-adjust">
							<input id="emailgenerique" name="emailgenerique" class="form-control" type="text" [(ngModel)]="emailGenerique" [maxLength]="255" />
						</div>
					</div>
					<div class="row row-margin">
						<!-- Fonction referent -->
						<label for="fonctionreferent" class="col-md-1 plus-half">Fonction R&eacute;f&eacute;rent&nbsp;:</label>
						<div class="col-md-2 plus-half padding-adjust">
							<input id="fonctionReferent" name="fonctionReferent" class="form-control" type="text" [(ngModel)]="fonctionReferent" [maxLength]="255" />
						</div>
						<!-- Telephone referent -->
						<label for="telreferent" class="col-md-1">T&eacute;l&eacute;phone R&eacute;f&eacute;rent&nbsp;:</label>
						<div class="col-md-3 padding-adjust">
							<input id="telephoneReferent" name="telephoneReferent" class="form-control" type="text" [(ngModel)]="telephoneReferent" [maxLength]="255" />
						</div>
					</div>
					<!-- Astreinte -->
					<div class="row row-margin">
						<label for="astreinte" class="col-md-1 plus-half">Astreinte&nbsp;&lowast;:</label>
						<div class="col-md-2 plus-half">
							<multi-editable-filterable-select
								[id]="'antenneAstreintes'"
								[labelGetter]="getNumeroAstreinteLabel"
								[initCommand]="initAstreinteCommand"
								[suggestionsCommand]="numeroAstreintesCommand"
								[existingValuesCommand]="existingAstreintesCommand"
								[placeholder]="'Saisir un numéro d\'astreinte'"
								[additionalStyleForInput]="mandatoryStepTwo ? ' error' : ''"
								(selectedItemsChange)="onNumeroAstreinteSelected($event)"
								>
							</multi-editable-filterable-select>
						</div>
					</div>
				</pannel>

				<!-- --------------- Liste des Entreprises Exterieures (EE) et Sous-Traitantes (ST) ---------------- -->
				<pannel [title]="'Liste des Entreprises Exterieures (EE) et Sous-Traitantes (ST)'">
					<table class="entrepriseexterieure" >
						<th>Entreprise (AURORA)</th>
						<th>Raison Sociale</th>
						<th>Nature des interventions</th>
						<th>Nom du responsable &lowast;</th>
						<th>Fonction du responsable</th>
						<th>T&eacute;l&eacute;phone</th>
						<th>Email</th>
						<th>Effectif moyen</th>
						<tr *ngFor="let entreprise of entreprisesExterieures; let index = index">
							<td> {{ entreprisesExterieuresData[entreprise.idEntrepriseExt].nomEntreprise }} </td>
							<td>
								<input class="form-control" type="text" (change)="setFieldValue($event, 'nomEntreprise', entreprise.idEntrepriseExt)"
									 [maxLength]="255" [value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].raisonSociale" />
							</td>
							<td> {{ getListeInterventionsForEntrepriseExterieure(entreprise.natureInterventions) }} </td>
							<td>
								<suggestable-input
									[inputClass]="'form-control' + (mandatoryStepTwo ? ' highlightable' : '')"
									[suggestionsObservableGetter]="suggestionsGetterForResponsable(entreprise.idEntrepriseExt)"
									[minimumSearchInput]="0"
									[categoryBuilders]="suggestionCategoryBuilders"
									[labelGetter]="getIntervenantLabel"
									[maxLength]="100"
									[value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].nomRepresentant"
									(valueChange)= "onNomRepresentantChange($event, entreprisesExterieuresData[entreprise.idEntrepriseExt])"
									(valueSelected)= "selectRepresentant($event, entreprise.idEntrepriseExt)"
									>
							</suggestable-input>
							</td>
							<td>
								<input class="form-control" type="text" (change)="setFieldValue($event, 'fonctionRepresentant', entreprise.idEntrepriseExt)"
									[value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].fonctionRepresentant" [maxLength]="100" />
							</td>
							<td class="telRepresentant">
								<filterable-select [inputClass]="'form-control'" [list]="indicatifsTel" [labelGetter]="getIndicatifLabel"
									(selectedItemChange)="setFieldValue($event, 'indicatifRepresentant', entreprise.idEntrepriseExt)"
									[(selectedItem)]="entreprisesExterieuresData[entreprise.idEntrepriseExt].indicatifRepresentant" >
								</filterable-select>
								<input class="form-control phone" type="text" (change)="setFieldValue($event, 'telephoneRepresentant', entreprise.idEntrepriseExt)"
									[value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].telephoneRepresentant" [maxLength]="36" />
							</td>
							<td>
								<input class="form-control" type="text" (change)="setFieldValue($event, 'emailRepresentant', entreprise.idEntrepriseExt)"
									[value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].emailRepresentant" [maxLength]="128" />
							</td>
							<td>
								<input class="form-control" type="text" (change)="setFieldValue($event, 'effectifMoyen', entreprise.idEntrepriseExt)"
									[value]="entreprisesExterieuresData[entreprise.idEntrepriseExt].effectifMoyen" min="0" type="number" />
							</td>
						</tr>
					</table>
				</pannel>
			</div>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-warning" [disabled]="isDisabled(2)" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				</div>
				<button mat-button matStepperPrevious type="button" class="btn btn-info">Back</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-success" [disabled]="isDisabled(2)" (click)="onCompletingTravauxEntreprise(stepper)">Next</button>
				</div>
			</div>
		</mat-step>

		<!--################################### STEP 3 ######################################-->
		<!-- ---------------------------Communication mutuelle d'informations------------------------------ -->
		<mat-step label="Communication mutuelle d&rsquo;informations" #step3>
			<communication-mutuelle-info [communicationMutuelleCommands]="communicationMutuelleCommands"
				[energieChangeCommand]="energieSubject"
				(onModelChange)="onCommunicationMutuelleInfoModelChange($event)"
				>
			</communication-mutuelle-info>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<button mat-button type="button" class="btn btn-warning" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				<button mat-button matStepperPrevious type="button" class="btn btn-info">Back</button>
				<button mat-button type="button" class="btn btn-success" (click)="onCompletingCommunicationMutuelleInfo(stepper)">Next</button>
			</div>
		</mat-step>

		<!--################################### STEP 4 ######################################-->
		<!-- ---------------------------Consignes de sécurités générales------------------------------ -->
		<mat-step label="Consignes de s&eacute;curit&eacute; g&eacute;n&eacute;rales" #step4>
			<consignes-securite-generales
				[energieChangeCommand]="energieSubject"
				>
			</consignes-securite-generales>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<button mat-button type="button" class="btn btn-warning" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				<button mat-button matStepperPrevious type="button" class="btn btn-info">Back</button>
				<button mat-button type="button btn btn-success" class="btn btn-success" (click)="onCompletingConsignesSecu(stepper)">Next</button>
			</div>
		</mat-step>

		<!--###################################### STEP 5 ########################################-->
		<!-- ---------------------------Analyse globale des risques------------------------------ -->
		<mat-step label="Analyse globale des risques" #step5>
			<analyse-globale-pdp
				[label1]="'Risques'"
				[label2]="'Mesure de prévention'"
				[type]="'RISK'" 
				[pdpToCopy]="pdpToCopyRisks" 
				[parentType]="'PARENT_ANA_RISK'"
				[highlightedSections]="highlightedSections" 
				[energieChangeCommand]="energieSubject"
				[analyseGlobaleCommands]="analyseRisquesCommands"
				(onModelChange)="onAnalyseRiskModelChange($event)" >
			</analyse-globale-pdp>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-warning" [disabled]="isDisabled(5)" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				</div>
				<button mat-button matStepperPrevious type="button" class="btn btn-info">Back</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-success" [disabled]="isDisabled(5)" (click)="onCompletingRiskStep(stepper)">Next</button>
					<span class="danger" *ngIf="aucunRiskChoisi">Vous devez renseigner au moins un risque</span>
				</div>
			</div>
		</mat-step>

		<!--###################################### STEP 6 ########################################-->
		<!-- ---------------------------Analyse globale des impacts------------------------------ -->
		<mat-step label="Analyse globale des Impacts environnementaux" #step6>
			<analyse-globale-pdp
				[label1]="'Impacts'"
				[label2]="'Mesure de prévention et de protection'"
				[type]="'IMPACT'" 
				[pdpToCopy]="pdpToCopyImpacts"
				[parentType]="'PARENT_ANA_IMPACT'"
				[highlightedSections]="highlightedSections" 
				[energieChangeCommand]="energieSubject" 
				[analyseGlobaleCommands]="analyseImpactsCommands"
				(onModelChange)="onAnalyseImpactModelChange($event)" >
			</analyse-globale-pdp>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-warning" [disabled]="isDisabled(6)" (click)="save(stepper)" *ngIf="planPreventionModel && planPreventionModel.etat === 3">Sauvegarder maintenant</button>
				</div>
				<button mat-button matStepperPrevious type="button" class="btn btn-info">Back</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-success" [disabled]="isDisabled(6)" (click)="onCompletingImpactStep(stepper)">Next</button>
				</div>
			</div>
		</mat-step>

		<!--###################################### STEP 7 ########################################-->
		<!-- ---------------------------Finalisation------------------------------ -->
		<mat-step label="Finalisation" #step7>
			<finalisation-pdp 
				[planPreventionCommands]="finalisationPdpCommands" 
				[typePdpCommands]="finalisationTypePdpCommands"
				[idPdpCommands]="finalisationIdPdpCommands"
				[versionPdpCommands]="finalisationVersionPdpCommands"
				[entreprisesPouvantSignerCommands]="finalisationEntreprisesPouvantSignerCommands"
				[entrepriseUtilisatriceCommands]="finalisationEntrepriseUtilisatriceCommands"
		  		[mandatoryField]="mandatoryStepSeven" 
				[pdpToCopy]="pdpToCopyInFinalisation" 
		  		(onModelChange)="onFinalisationModelChange($event)" ></finalisation-pdp>
			<div class="stepper-footer">
				<button mat-button type="button" class="btn btn-danger" (click)="gotoListPdp(stepper)">Liste des PDP</button>
				<button mat-button matStepperPrevious type="button" class="btn btn-info btn-default">Back</button>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-success" [disabled]="isDisabled(7)" (click)="onCompletingFinalisation(stepper, false)">Sauvegarder</button>
				</div>
				<div style="display: inline">
					<button mat-button type="button" class="btn btn-primary" [disabled]="isDisabled(7)" (click)="onCompletingFinalisation(stepper, true)">Exporter</button>
				</div>
			</div>
		</mat-step>

	</mat-horizontal-stepper>
</form>

<pdp-generation [id]="'pdpGenerationDialogInStepFinalisation'" [generationCommands]="generationCommands" (decisionIssued)="onPdpGenerationDecision($event)"></pdp-generation>